import { createV3Queries } from "@query/utils/createV3Queries";
import { invoicesApi } from "@api";

import { queriesInvoiceRows } from "./queriesInvoiceRows";
import { queriesPayables } from "./queriesPayables";
import { queriesPayableRows } from "./queriesPayableRows";

const reviewDependencies = () => [
  queriesInvoiceRows.searchInvoiceRows.queryKeyBase,
  queriesPayables.getPayable.queryKeyBase,
  queriesPayableRows.searchPayableRows.queryKeyBase
];

export const queriesInvoices = createV3Queries("invoicesApi", invoicesApi, {
  acceptInvoice: () => ({ dependencies: reviewDependencies }),
  disputeInvoice: () => ({ dependencies: reviewDependencies })
});
